import { Link } from 'react-router-dom';

function PropertyCard({ property }) {
  return (
    <Link to={`/property/${property.id}`} className="no-underline">
      <div className="p-6 bg-white/10 rounded-xl border border-white/10 backdrop-blur-md">
        <img 
          src={property.imageUrl || 'https://placehold.co/600x400?text=No+Image'} 
          alt={property.title} 
          className="mb-2 rounded-lg object-cover w-full h-48" 
        />
        <h3 className="text-xl font-semibold mb-2">{property.title}</h3>
        <p className="text-sm text-gray-300">{property.description}</p>
      </div>
    </Link>
  );
}

export default PropertyCard;
